var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHistoryLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 32,
    viewBox: "0 0 140 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e8390e;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M175.245-75.587c2.8.141,3.61.948,3.61,4.318v21.813h5.43V-77.726l-9.04,1.189Z",
    transform: "translate(-127.783 78.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.989-57.749c2.805.143,3.612.948,3.612,4.324v13.989h5.434v-20.45l-9.047,1.19Z",
    transform: "translate(-143.929 68.939)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M214.8-80.543A2.967,2.967,0,0,0,211.81-77.6a2.969,2.969,0,0,0,2.942,2.994,3.065,3.065,0,0,0,3.089-2.994A3.013,3.013,0,0,0,214.8-80.543Z",
    transform: "translate(-148.323 80.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M239.41-56.255c0-1.883,1.944-2.4,3.581-2.4a12.221,12.221,0,0,1,6.077,2.1V-59.84a26.555,26.555,0,0,0-5.723-.745c-6.031,0-8.534,2.714-8.534,5.857,0,6.347,11.191,6.6,11.191,10.579,0,1.53-1.173,2.925-4.394,2.925a13.425,13.425,0,0,1-6.748-2.269v3.4a27.964,27.964,0,0,0,6.54.791c5.065,0,9.206-1.753,9.206-6.031C250.605-52.85,239.41-52.353,239.41-56.255Z",
    transform: "translate(-161.243 69.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.138-59.1c2.943,0,3.262,2.705,3.262,4.5h5.916c0-3.544-3.62-5.99-8.891-5.99-6.793,0-9.665,4.374-9.665,10.358,0,6.6,4.156,10.931,10.805,10.931a16.353,16.353,0,0,0,6.74-1.054v-1.917a18.038,18.038,0,0,1-4.557.609c-4.321,0-7.34-3.541-7.34-10.007C283.41-55.861,283.912-59.1,287.138-59.1Z",
    transform: "translate(-185.37 69.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M337.122-60.585c-6.936,0-10.516,3.365-10.516,10.667,0,6.116,2.867,10.622,10.516,10.622,7.026,0,10.5-3.5,10.5-10.622C347.619-56.211,344-60.585,337.122-60.585Zm0,19.8c-4.706,0-4.781-5.5-4.781-9.132,0-3.85.075-9.177,4.781-9.177,4.607,0,4.793,5.155,4.793,9.177C341.915-45.551,341.772-40.786,337.122-40.786Z",
    transform: "translate(-212.808 69.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.8-36.453c-3.616-1.894-7.591-4.273-9.869-9.427l-.632.134c.334,2.92,1.7,9.888,6.2,13.551,1.94,1.568,3.866,1.376,5.077.342A2.839,2.839,0,0,0,105.8-36.453Z",
    transform: "translate(-82.871 61.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M94.14-77.764c-9.067,0-15.378,5.529-18.155,13.21V-77.747l-9.038,1.189v.95c2.8.141,3.611.948,3.611,4.318v21.813h5.427v-6.608c.262-10.654,6.271-17.878,16.48-17.878,8.916,0,15.109,5.835,15.109,14.426l.007,3.166c0,2.881-1.707,4.85-4.759,4.85-2.172,0-3.5-1.585-3.5-4.344,0-4.51,4.473-6.825,6.185-6.87l.073-.93c-3.042.1-11.831,1.913-11.831,8.609,0,2.8,1.927,6.1,7.218,6.1,3.659,0,5.721-1.525,6.619-3v.1a2.5,2.5,0,0,0,2.708,2.535h2.8l-.016-10.289C113.068-71.567,103.68-77.764,94.14-77.764Z",
    transform: "translate(-66.947 78.982)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 140,
    height: 32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLogo02);
export default __webpack_public_path__ + "static/media/history_logo_02.ec4150cf4dba6e0a7313b380de6baf0d.svg";
export { ForwardRef as ReactComponent };